import { render, staticRenderFns } from "./buscarDigitales.vue?vue&type=template&id=6e1181a8"
import script from "./buscarDigitales.vue?vue&type=script&lang=js"
export * from "./buscarDigitales.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports